import { render, staticRenderFns } from "./a.vue?vue&type=template&id=60317638"
import script from "./a.vue?vue&type=script&lang=js"
export * from "./a.vue?vue&type=script&lang=js"
import style0 from "./a.vue?vue&type=style&index=0&id=60317638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports